import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderSlot as _renderSlot, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "right-sheet-title" };
const _hoisted_2 = { class: "bottom-sheet-title" };
const _hoisted_3 = { class: "bottom-sheet-content" };
const _hoisted_4 = {
    key: 2,
    class: "bottom-sheet-footer"
};
import { ref, computed, watch, onUnmounted, getCurrentInstance } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SimpleDrawerPanel',
    props: {
        modelValue: { type: Boolean },
        title: {},
        height: {},
        direction: { default: 'bottom' },
        closeButton: { type: Boolean, default: false }
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const isRight = computed(() => props.direction === 'right');
        const instance = getCurrentInstance();
        const cookies = instance?.appContext.config.globalProperties.$cookies;
        const safeTop = computed(() => parseInt(cookies?.get('st') ?? '0'));
        const emit = __emit;
        const dragOffset = ref(0);
        const isDragging = ref(false);
        let touchStartY = 0;
        let panelHeight = 0;
        const panelStyle = computed(() => {
            const base = {};
            if (props.height)
                base.height = props.height;
            if (dragOffset.value > 0)
                base.transform = `translateY(${dragOffset.value}px)`;
            return base;
        });
        function onTouchStart(e) {
            touchStartY = e.touches[0].clientY;
            const panel = e.currentTarget.closest('.bottom-sheet-panel');
            panelHeight = panel?.offsetHeight ?? window.innerHeight;
            isDragging.value = true;
        }
        function onTouchMove(e) {
            if (!isDragging.value)
                return;
            const delta = e.touches[0].clientY - touchStartY;
            dragOffset.value = Math.max(0, delta);
        }
        function onTouchEnd() {
            if (!isDragging.value)
                return;
            const shouldClose = dragOffset.value > panelHeight * 0.25;
            isDragging.value = false;
            dragOffset.value = 0;
            if (shouldClose)
                close();
        }
        function lockScroll() {
            const scrollY = window.scrollY;
            document.body.style.position = 'fixed';
            document.body.style.width = '100%';
            document.body.style.top = `-${scrollY}px`;
        }
        function unlockScroll() {
            if (document.body.style.position !== 'fixed')
                return;
            const scrollY = document.body.style.top;
            document.body.style.position = '';
            document.body.style.width = '';
            document.body.style.top = '';
            window.scrollTo(0, parseInt(scrollY || '0') * -1);
        }
        watch(() => props.modelValue, (open) => {
            if (open)
                lockScroll();
            else
                unlockScroll();
        });
        onUnmounted(() => {
            unlockScroll();
        });
        function close() {
            emit('update:modelValue', false);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                _createVNode(_Transition, {
                    name: isRight.value ? 'right-sheet' : 'bottom-sheet'
                }, {
                    default: _withCtx(() => [
                        (_ctx.modelValue)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass(["bottom-sheet-overlay", { 'is-right': isRight.value }]),
                                onClick: _withModifiers(close, ["self"]),
                                onTouchmove: _cache[0] || (_cache[0] = _withModifiers(() => { }, ["self", "prevent"]))
                            }, [
                                _createElementVNode("div", {
                                    class: _normalizeClass(["bottom-sheet-panel", { 'is-dragging': isDragging.value, 'is-right': isRight.value }]),
                                    style: _normalizeStyle(panelStyle.value)
                                }, [
                                    (isRight.value)
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 0,
                                            class: "right-sheet-header",
                                            style: _normalizeStyle({ paddingTop: (16 + safeTop.value) + 'px' })
                                        }, [
                                            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "header-btn" }, null, -1)),
                                            _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.title), 1),
                                            _createElementVNode("div", {
                                                class: "header-btn header-close",
                                                onClick: close
                                            }, "✕")
                                        ], 4))
                                        : (_openBlock(), _createElementBlock("div", {
                                            key: 1,
                                            class: "bottom-sheet-banner",
                                            onClick: close,
                                            onTouchstartPassive: onTouchStart,
                                            onTouchmove: _withModifiers(onTouchMove, ["prevent"]),
                                            onTouchend: onTouchEnd,
                                            onTouchcancel: onTouchEnd
                                        }, [
                                            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "bottom-sheet-handle" }, [
                                                _createElementVNode("div", { class: "handle-bar" })
                                            ], -1)),
                                            _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1),
                                            (_ctx.closeButton)
                                                ? (_openBlock(), _createElementBlock("div", {
                                                    key: 0,
                                                    class: "bottom-sheet-close",
                                                    onClick: _withModifiers(close, ["stop"])
                                                }, "✕"))
                                                : _createCommentVNode("", true)
                                        ], 32)),
                                    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "bottom-sheet-divider" }, null, -1)),
                                    _createElementVNode("div", _hoisted_3, [
                                        _renderSlot(_ctx.$slots, "default")
                                    ]),
                                    (_ctx.$slots.footer)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                            _renderSlot(_ctx.$slots, "footer")
                                        ]))
                                        : _createCommentVNode("", true)
                                ], 6)
                            ], 34))
                            : _createCommentVNode("", true)
                    ]),
                    _: 3
                }, 8, ["name"])
            ]));
        };
    }
});
